import createDebug from 'debug';

/**
 * 开启日志需在控制台输入代码执行
 *
 * ```js
 * localStorage.debug = '*'
 * ```
 */

/** 用来作为开关（默认不打印堆栈跟踪信息，使用 localStorage.debug = '*,-*notrace' 开启堆栈信息打印） */
const debugStackTraceSwitch = createDebug('StandardChart:notrace');

function logWithStackTrace(logger: createDebug.Debugger) {
  if (!debugStackTraceSwitch.enabled) {
    // eslint-disable-next-line
    logger.log = console.trace.bind(console);
  }

  return logger;
}

/** 调试主程序 */
export const debug = logWithStackTrace(createDebug('StandardChart'));
